import { useQuoteI18n } from '../quoteI18n'

/**
 * Esito della prenotazione, mostrato sulla pagina che il viaggiatore ha già davanti.
 *
 * Prima queste informazioni esistevano solo dentro l'email di conferma: chi non la
 * riceveva — e finché la casella del cliente non è configurata è il caso di tutti —
 * riapriva il preventivo e leggeva "Preventivo scaduto" pur avendo prenotato.
 *
 * @param {Object} props
 * @param {string} props.tripCode - Codice viaggio Goelett
 * @param {string} [props.tripStatus] - Stato del trip (Confirmed / PendingApproval / …)
 * @param {string} [props.cartLink] - Deep-link al viaggio nel portale Goelett
 */
export function BookingResult({ tripCode, tripStatus, cartLink }) {
  const { t } = useQuoteI18n()
  const pending = tripStatus === 'PendingApproval'

  return (
    <div className={`gq-panel gq-panel--${pending ? 'warning' : 'success'}`} role="status">
      <div className="gq-panel__icon" aria-hidden="true">
        {pending ? '⏳' : '✓'}
      </div>
      <h2 className="gq-panel__title">
        {pending ? t.result.pendingTitle : t.result.confirmedTitle}
      </h2>
      <p className="gq-panel__text">{pending ? t.result.pendingText : t.result.confirmedText}</p>

      {tripCode && (
        <p className="gq-panel__code">
          {t.result.tripCode} <strong>{tripCode}</strong>
        </p>
      )}

      {cartLink && (
        <a className="gq-panel__cta" href={cartLink} target="_blank" rel="noreferrer">
          {t.result.openPortal}
        </a>
      )}
    </div>
  )
}
